import { Controller } from 'stimulus'

export default class extends Controller {
  onDeleteSequence(e) {
    const [data, status, xhr] = e.detail
    $('#selected_sequences').html(xhr.response)
    $('.btn_download_tree, .btn_view_tree, .btn_generate_tree, .btn_download_alignment, .btn_generate_alignment, .btn_download_collection').addClass('disabled')
    $('#toggle_phylogenetic_tree_options, .phylogenetic-tree-canvas-tab').hide()
  }
}